// given a string and a count, return the pluralized string
export function pluralize(str: string, count: number) {
  // make more robust if needed
  return count === 1 ? str : str + "s"
}
